const Logo = (props) => (
  <img
    alt="Logo"
    src="/static/logo.svg"
    {...props}
  />
);

export default Logo;
